import { ModalContext } from "app/app";
import { Fragment, useContext } from 'react';
import styles from "./styles.module.scss";
import axios from "axios";
import { ViewContext } from "components/lib";
import { useState } from "react";

export function CloseTicketModal() {
  const { modal, setModal } = useContext(ModalContext);
  const context = useContext(ViewContext);

  const [sending, setSending] = useState(false);

  const handleCancel = () => {
    setModal("");
  };

  const handleConfirm = async () => {
    setSending(true);
    try {
      const response = await axios.put(`/api/tickets/${modal.data.id}`, 
        {
          status: 'Finished',
          ticketStatus: 'Completed',
        }, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      if (response.data.success) {
        context.notification.show(
          "Ticket closed successfully!",
          "success",
          true,
          "toast",
          "check-circle"
        );
        setSending(false);
        setModal("");
        window.location.reload();
      }
    } catch (error) {
      context.notification.show(
        "Couldn't change ticket status, please try again later.",
        "error",
        true,
        "toast",
        "check-circle"
      );
    }
  };

  return (
    <Fragment>
      {modal.name === "complete_ticket_modal" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              {modal.data.ticketStatus === 'Completed' ? (
                <>
                  <div
                    style={{
                      fontStyle: "normal",
                      fontSize: 22,
                      marginBottom: 10,
                      marginLeft: 20,
                      color: "black",
                    }}
                  >
                    Ticket Finished
                  </div>
                  <div
                    style={{
                      fontStyle: "normal",
                      fontSize: 16,
                      marginBottom: 20,
                      marginLeft: 20,
                      color: "black",
                    }}
                  >
                    This ticket has already been closed and cannot be reopened. 
                  </div>
                  <div
                    className={styles.footer}
                    style={{ justifyContent: "end", paddingRight: '8px' }}
                  >
                    <div className={styles.buttons}>
                      <button
                        className={styles.save}
                        onClick={handleCancel}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div
                    style={{
                      fontStyle: "normal",
                      fontSize: 22,
                      marginBottom: 10,
                      marginLeft: 20,
                      color: "black",
                    }}
                  >
                    Complete Ticket
                  </div>
                  <div
                    style={{
                      fontStyle: "normal",
                      fontSize: 16,
                      marginBottom: 20,
                      marginLeft: 20,
                      color: "black",
                    }}
                  >
                    Are you sure you want to complete and close your ticket?
                  </div>
                  <div
                    className={styles.footer}
                    style={{ justifyContent: "end", paddingRight: '8px' }}
                  >
                    <div className={styles.buttons}>
                      <button
                        className={styles.cancel}
                        onClick={handleCancel}
                      >
                        Cancel
                      </button>
                      <button
                        className={styles.save}
                        onClick={handleConfirm}
                        disabled={sending}
                      >
                        {sending ? "Sending..." : "Confirm"}
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}